<template>
    <div class="custom-automation-card border rounded">
        <div>
            Create templates from custom {{ entityName }} for everyone on your team to use
        </div>
        <button @click="onCreateCustomAutomation" class="btn btn-sm btn-primary mt-3">
            Create Custom {{ entityName }}
        </button>
    </div>
</template>

<script>
import {AutomationTypes, getAutomationTypeBaseModelById} from '../../../types/automations/types'
import {getCustomAutomationBaseModel} from '@/types/automations/utils'

export default {
    name: 'AutomationCreateCustomBanner',
    props: {
        type: {
            type: String,
            required: true,
            default: AutomationTypes.AUTOMATION
        }
    },
    computed: {
        entityName() {
            return getAutomationTypeBaseModelById(this.type).name
        }
    },
    methods: {
        onCreateCustomAutomation() {
            this.$emit('create', getCustomAutomationBaseModel({type: this.type}))
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-automation-card {
    padding: 30px;
    background: white;
    box-shadow: $box-shadow-sm;
}
</style>
